import { render } from "./VehiclePdfStep.vue?vue&type=template&id=2ed98a7d&scoped=true"
import script from "./VehiclePdfStep.vue?vue&type=script&lang=js"
export * from "./VehiclePdfStep.vue?vue&type=script&lang=js"

import "./VehiclePdfStep.vue?vue&type=style&index=0&id=2ed98a7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed98a7d"]])

export default __exports__